import axios from 'axios';

export default {
    loadUserData() {
        return axios.get('/colab/epr/user/me');
    },

    updateMe(user) {
        return axios.post('/colab/epr/user/me', user);
    },

    logout() {
        return axios.get('/colab/epr/logout');
    },

    loadSignedInUsersCount() {
        return axios.get('/colab/epr/user/signedIn/count');
    },

    getUserSettings() {
        return axios.get('/colab/epr/user/settings');
    },

    setSplitterPercent(percent) {
        return axios.put('/colab/epr/user/settings/splitter', percent);
    }
};
